

<div *ngIf="ShowFailureMessage" class="bgColor">
    <h1 class="errorHeader">Something went wrong</h1>
    <p class="message">After a successful payment there was a failure creating the curriculum student assignment. Please contact customer service to activate your purchase.</p>
    
</div>

<div *ngIf="ShowInvoiceMessage">
    <h1 class="errorHeader">Thank you for your purchase!</h1>
    <p class="message">An invoice of your purchase has been sent to the email of the primary account.</p>
    
</div>

<div *ngIf="loading" class="spinner-wrapper">
    <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
  </div>